import { useFormikContext } from "formik";
import { useDEFormContext } from "../context/DEFormContext";

const StatusSection = () => {
  const formik = useFormikContext();
  const {
    resultDeOption,
    punishmentTypeOption,
    punishmentOption,
    punishmentImposed,
    defaultPunishment,
  } = useDEFormContext();

  return (
    <>
      <div className="form-group row mb-3">
        <label className="col-sm-4 col-form-label">
          Result of Departmental Action
        </label>
        <div className="col-sm-8">
          <select
            className="form-control"
            name="deResultDe"
            value={formik.values.deResultDe}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          >
            <option value="">Select Result of Departmental Action </option>
            {resultDeOption?.map((opt) => (
              <option key={opt.id} value={opt.name}>
                {opt.name}
              </option>
            ))}
          </select>
          {formik.touched.deResultDe && formik.errors.deResultDe && (
            <div className="invalid-feedback d-block">
              {formik.errors.deResultDe}
            </div>
          )}
        </div>
      </div>
      {formik.values.deResultDe == punishmentImposed && (
        <>
          {/* punishment Type */}
          <div hidden className="form-group row mb-3">
            <label className="col-sm-4 col-form-label">Punishment Type</label>
            <div className="col-sm-8">
              <select
                className="form-control"
                name="dePunishmentType"
                value={formik.values.dePunishmentType}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              >
                <option value="">Select Punishment Type </option>
                {punishmentTypeOption?.map((opt) => (
                  <option key={opt.id} value={opt.id}>
                    {opt.name}
                  </option>
                ))}
              </select>
              {formik.touched.dePunishmentType &&
                formik.errors.dePunishmentType && (
                  <div className="invalid-feedback d-block">
                    {formik.errors.dePunishmentType}
                  </div>
                )}
            </div>
          </div>

          {/* Punishment from master data */}
          <div className="form-group row mb-3">
            <label className="col-sm-4 col-form-label">Punishment</label>
            <div className="col-sm-8">
              <select
                className="form-control"
                name="dePunishment"
                value={formik.values.dePunishment}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              >
                <option value="">Select Punishment </option>
                {punishmentOption?.map((opt) => (
                  <option key={opt.id} value={opt.id}>
                    {opt.name}
                  </option>
                ))}
              </select>
              {formik.touched.dePunishment && formik.errors.dePunishment && (
                <div className="invalid-feedback d-block">
                  {formik.errors.dePunishment}
                </div>
              )}
            </div>
          </div>
          <div className="form-group row mb-3">
            <label className="col-sm-4 col-form-label">
              Date Of Punishment Order
            </label>
            <div className="col-sm-8">
              <input
                type="date"
                className="form-control"
                name="deDatePunishmentOrder"
                value={formik.values.deDatePunishmentOrder}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                onClick={(e) => e.target.showPicker && e.target.showPicker()}
              />
              {formik.touched.deDatePunishmentOrder &&
                formik.errors.deDatePunishmentOrder && (
                  <div className="invalid-feedback d-block">
                    {formik.errors.deDatePunishmentOrder}
                  </div>
                )}
            </div>
          </div>

          {Object.values(defaultPunishment).includes(
            formik.values.dePunishment,
          ) && (
            <>
              <div className="form-group row mb-3">
                <label className="col-sm-4 col-form-label">
                  No. of increment stopped
                </label>
                <div className="col-sm-8">
                  <input
                    type="number"
                    className="form-control"
                    name="annualStoppage"
                    value={formik.values.annualStoppage}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.annualStoppage &&
                    formik.errors.annualStoppage && (
                      <div className="invalid-feedback d-block">
                        {formik.errors.annualStoppage}
                      </div>
                    )}
                </div>
              </div>
            </>
          )}
        </>
      )}
    </>
  );
};

export default StatusSection;
